import { FeedCurveInfo } from "../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
  
  export const TestData: FeedCurveInfo[] = [
    {
      id: 1,
      name: "Duroc Standard",
      default: true,
      active: true,
      
      
      milestones: [
        {milestone: "Insemination", startDay: 1},
        {milestone: "Farrowing", startDay: 3},
        {milestone: "Weaning", startDay: 5}
      ],
      mixture:[
          {day: 1, component: 1, amount: 0.5},
          {day: 1, component: 3, amount: 0.75},
          {day: 1, component: 4, amount: 0.75},
          {day: 2, component: 1, amount: 0.5},
          {day: 2, component: 3, amount: 0.75},
          {day: 3, component: 1, amount: 0.5},
          {day: 3, component: 2, amount: 0.5},
          {day: 4, component: 1, amount: 0.5},
          {day: 4, component: 2, amount: 0.5},
          {day: 5, component: 1, amount: 0.5},
          {day: 5, component: 2, amount: 0.5},
          {day: 6, component: 2, amount: 0.5},
          {day: 7, component: 4, amount: 0.5},
          {day: 8, component: 4, amount: 0.5},
          {day: 9, component: 4, amount: 0.5},
          {day: 10, component: 4, amount: 1},
      ],
    },
    {
      id: 3,
      name: "CTO Standard Feed",
      default: true,
      active: true,
      
      
      milestones: [
        {milestone: "Insemination", startDay: 1, },
        {milestone: "Farrowing", startDay: 3, },
        {milestone: "Weaning", startDay: 5, }
      ],
      
      mixture:[
          {day: 1, component: 1, amount: 0.1},
          {day: 5, component: 1, amount: 0.5},
          {day: 6, component: 1, amount: 0},
          {day: 2, component: 2, amount: 0},
          {day: 4, component: 2, amount: 0.5},
          {day: 6, component: 2, amount: 0.5},
          {day: 7, component: 2, amount: 0},
          {day: 1, component: 3, amount: 0.5},
          {day: 2, component: 3, amount: 0.75},
          {day: 3, component: 3, amount: 0},
          {day: 1, component: 4, amount: 0.75},
          {day: 2, component: 4, amount: 0},
          {day: 6, component: 4, amount: 0},
          {day: 7, component: 4, amount: 0.5},
          {day: 11, component: 4, amount: 0.75},
          {day: 12, component: 4, amount: 1},
        ],
      },
        {
      id: 2,
      name: "Duroc Skinny",
      default: true,
      active: true,
      
      
      milestones: [
        {milestone: "Insemination", startDay: 1, },
        {milestone: "Farrowing", startDay: 3, },
        {milestone: "Weaning", startDay: 5, }
      ],

      mixture:[
          {day: 1, component: 7, amount: 0.5},
          {day: 1, component: 8, amount: 0.75},
          {day: 1, component: 9, amount: 0.75},
          {day: 2, component: 7, amount: 0.5},
          {day: 2, component: 8, amount: 0.75},
          {day: 3, component: 7, amount: 0.5},
          {day: 3, component: 8, amount: 0.5},
          {day: 4, component: 7, amount: 0.5},
          {day: 4, component: 8, amount: 0.5},
          {day: 5, component: 7, amount: 0.5},
          {day: 5, component: 8, amount: 0.5},
          {day: 6, component: 7, amount: 0.5},
          {day: 7, component: 7, amount: 0.5},
          {day: 8, component: 7, amount: 0.5},
          {day: 9, component: 7, amount: 0.5},
          {day: 10, component: 7, amount: 1},
        ],
      }, {
        id: 4,
        name: "CTO Skinny Feed",
        default: true,
        active: true,
        
        
        milestones: [
          {milestone: "Insemination", startDay: 1, },
          {milestone: "Farrowing", startDay: 5, },
          {milestone: "Weaning", startDay: 11, }
        ],
        
        mixture:[
            {day: 1, component: 1, amount: 0.1},
            {day: 2, component: 1, amount: 0.2},
            {day: 4, component: 1, amount: 0.4},
            {day: 5, component: 1, amount: 0.5},
            {day: 4, component: 2, amount: 0.5},
            {day: 5, component: 2, amount: 0.5},
            {day: 6, component: 2, amount: 0.5},
            {day: 1, component: 3, amount: 0.5},
            {day: 2, component: 3, amount: 0.75},
            {day: 1, component: 4, amount: 0.75},
            {day: 7, component: 4, amount: 0.5},
            {day: 11, component: 4, amount: 0.75},
            {day: 12, component: 4, amount: 1},
          ],
        },{
        id: 6,
        name: "CTO static curve",
        default: true,
        active: true,
        
        milestones: [
          {milestone: "Insemination", startDay: 1, },
        ],
        
        mixture:[
            {day: 1, component: 9, amount: 2.5},
          ],
        },{
          id: 7,
          name: "CTO Skinny Gestation Feed",
          default: true,
          active: true,
          
          
          milestones: [
            {milestone: "Insemination", startDay: 1, },
            {milestone: "Farrowing", startDay: 5, },
            {milestone: "Weaning", startDay: 11, }
          ],
          
          mixture:[
              {day: 1, component: 1, amount: 0.1},
              {day: 2, component: 1, amount: 0.2},
              {day: 4, component: 1, amount: 0.4},
              {day: 5, component: 1, amount: 0.5},
              {day: 4, component: 2, amount: 0.5},
              {day: 5, component: 2, amount: 0.5},
              {day: 6, component: 2, amount: 0.5},
              {day: 1, component: 3, amount: 0.5},
              {day: 2, component: 3, amount: 0.75},
              {day: 1, component: 4, amount: 0.75},
              {day: 2, component: 4, amount: 0},
              {day: 4, component: 4, amount: 1},
              {day: 7, component: 4, amount: 0.5},
              {day: 11, component: 4, amount: 0.75},
              {day: 12, component: 4, amount: 1},
              {day: 7, component:9, amount: 0.5},
              {day: 11, component:9, amount: 0.25},
            ],
          }
  ]

// Function to get a feedcurve by ID
export function getFeedCurveById(id: number): FeedCurveInfo | undefined {
    return TestData.find(feedCurve => feedCurve.id === id);
}